// extracted by mini-css-extract-plugin
export var banner = "_pt-0";
export var settingRow = "_pt-2";
export var titleIcon = "_pt-1";